// Har bir metod uchun 5 ta savol (jami 35)
export const quizzes = {
    "3I": {
        title: "3I metodi",
        questions: [
            { q: "3I metodi nechta asosiy tamoyilga asoslanadi?", options: ["2", "3", "4", "5"], correct: 1 },
            { q: "3I metodidagi 'I' harflari nimani anglatadi?", options: ["Innovation, Internet, Idea", "Individualization, Interaction, Integration", "Information, Idea, Inspiration", "Input, Initiative, Inquiry"], correct: 1 },
            { q: "Individualizatsiya bosqichida nima qilinadi?", options: ["Test o'tkaziladi", "Har bir o'quvchining ehtiyoji aniqlanadi", "Dars videoga olinadi", "Uyga vazifa beriladi"], correct: 1 },
            { q: "Interaktsiya bosqichi nimaga yo'naltirilgan?", options: ["Mustaqil o'qish", "Hamkorlik va o'zaro muloqot", "Imtihon", "Dam olish"], correct: 1 },
            { q: "Integratsiya bosqichi qanday vazifani bajaradi?", options: ["Bilimlarni amaliyotga bog'lash", "O'quvchini baholash", "Materialni yodlash", "Sinfni tartibga solish"], correct: 0 },
        ],
    },
    "CLIL": {
        title: "CLIL metodi",
        questions: [
            { q: "CLIL qisqartmasi nima ma'noni bildiradi?", options: ["Content and Language Integrated Learning", "Computer Learning Interactive Lesson", "Creative Language Improvement Lab", "Classic Literature Independent Learning"], correct: 0 },
            { q: "CLIL ning 4 ta 'C' tarkibida qaysi yo'q?", options: ["Content", "Communication", "Cognition", "Calculation"], correct: 3 },
            { q: "CLIL qanday fanlarda samarali?", options: ["Faqat ingliz tilida", "Faqat matematikada", "Til va boshqa fanlarni integratsiya qilishda", "Faqat tarixda"], correct: 2 },
            { q: "CLIL ning asosiy maqsadi?", options: ["Faqat til o'rgatish", "Mazmun va tilni birgalikda o'rgatish", "Test o'tkazish", "Loyiha yozish"], correct: 1 },
            { q: "Madaniyat (Culture) komponentining roli?", options: ["Ahamiyatsiz", "Madaniy kontekstda o'rgatish", "Faqat shoirlarni o'rganish", "Sayohat qilish"], correct: 1 },
        ],
    },
    "SQ3R": {
        title: "SQ3R metodi",
        questions: [
            { q: "SQ3R bosqichlari ketma-ketligi qanday?", options: ["Survey, Question, Read, Recite, Review", "Study, Question, Read, Read, Review", "Survey, Quiz, Read, Recite, Repeat", "Search, Question, Read, Recite, Review"], correct: 0 },
            { q: "Survey bosqichida nima qilinadi?", options: ["Test yechiladi", "Matnni umumiy ko'zdan kechirish", "Eslab qoladi", "Konspekt yoziladi"], correct: 1 },
            { q: "Question bosqichi maqsadi?", options: ["Imtihon savollarini topish", "Sarlavhalardan savollar tuzish", "O'qituvchiga savol berish", "Forumdan savol olish"], correct: 1 },
            { q: "Recite bosqichida o'quvchi nima qiladi?", options: ["Qayta o'qiydi", "O'qiganini o'z so'zlari bilan aytadi", "Yozadi", "Tarjima qiladi"], correct: 1 },
            { q: "SQ3R qaysi sohada eng samarali?", options: ["Matn bilan ishlashda", "Sport mashg'ulotida", "Rasm chizishda", "Musiqada"], correct: 0 },
        ],
    },
    "GRASPS": {
        title: "GRASPS metodi",
        questions: [
            { q: "GRASPS qaysi yondashuvga asoslanadi?", options: ["Yodlash", "Muammoli vaziyat", "Test", "Ma'ruza"], correct: 1 },
            { q: "GRASPSdagi 'G' nimani anglatadi?", options: ["Grade", "Goal", "Group", "Graph"], correct: 1 },
            { q: "'R' harfi qaysi komponentni bildiradi?", options: ["Read", "Role", "Result", "Review"], correct: 1 },
            { q: "Audience komponenti nimani belgilaydi?", options: ["O'qituvchini", "Mahsulot kimga mo'ljallanganini", "Sinfni", "Vaqtni"], correct: 1 },
            { q: "Standards komponenti nima uchun zarur?", options: ["Baholash mezonlari", "Sinf nomi", "Yil davomida rejasi", "Maktab logotipi"], correct: 0 },
        ],
    },
    "SMART": {
        title: "SMART metodi",
        questions: [
            { q: "SMART so'zining birinchi harfi nimani anglatadi?", options: ["Simple", "Specific", "Strong", "Student"], correct: 1 },
            { q: "'M' harfi nima ma'no beradi?", options: ["Method", "Measurable", "Modern", "Master"], correct: 1 },
            { q: "Achievable nimani anglatadi?", options: ["Murakkab", "Erishish mumkin bo'lgan", "Avtomatik", "Aniq emas"], correct: 1 },
            { q: "Time-bound qaysi xususiyatni belgilaydi?", options: ["Vaqtga bog'liq muddat", "Vaqtsiz reja", "Mavjud vaqt", "Yo'q narsa"], correct: 0 },
            { q: "SMART asosan nima uchun ishlatiladi?", options: ["Maqsadlarni belgilash", "Test yechish", "Rasm chizish", "Yodlash"], correct: 0 },
        ],
    },
    "WHERETO": {
        title: "WHERETO metodi",
        questions: [
            { q: "WHERETO qaysi sohaga tegishli?", options: ["Mashg'ulotni rejalashtirish", "Hisob-kitob", "Sport", "Tibbiyot"], correct: 0 },
            { q: "'H' harfi nimani bildiradi?", options: ["Help", "Hook (qiziqtirish)", "Home", "Hour"], correct: 1 },
            { q: "'E' (birinchi) harfi nimani anglatadi?", options: ["Eat", "Equip (ta'minlash)", "End", "Excel"], correct: 1 },
            { q: "'R' qaysi bosqichni bildiradi?", options: ["Read", "Rethink (qayta o'ylash)", "Run", "Repeat"], correct: 1 },
            { q: "'T' nimani anglatadi?", options: ["Test", "Tailor (moslashtirish)", "Time", "Teach"], correct: 1 },
        ],
    },
    "qosh_daraxt": {
        title: "Qo'sh daraxt metodi",
        questions: [
            { q: "Qo'sh daraxt metodi qaysi turdagi vositadir?", options: ["Test", "Grafik organayzer", "Audio", "Video"], correct: 1 },
            { q: "Markazda nima joylashtiriladi?", options: ["Tushuncha yoki mavzu", "Test natijasi", "Rasm", "Sana"], correct: 0 },
        ],
    },
};
